import React, { useRef, useState, useMemo } from 'react';
import bgImage from '../assets/Home.png';
import img from '../assets/gear.png';
import SendIcon from '@mui/icons-material/Send';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import '../index.css';
import { WorkOutline, Article, Search, Groups, HowToReg } from '@mui/icons-material';
import gear from '../assets/contact_us.svg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { FaQuoteLeft, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { ChevronDown, HelpCircle, Shield, Users, Zap, Target, Settings } from 'lucide-react';
import { ChevronRight, Circle } from 'lucide-react';
import { FaArrowUp } from 'react-icons/fa'; // make sure you have react-icons installed
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const HeroSection = ({ contactRef }) => {
    const [openItems, setOpenItems] = useState(new Set([0])); // First item open by default
    const [searchTerm, setSearchTerm] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);

    const tabs = [
        {
            key: 'hr',
            label: 'HR/Admin',
            headline: 'Your Central Command for Smarter Hiring',
            content: [
                'Create and manage job posts effortlessly',
                'Screen candidates using resume scoring & filters',
                'Communicate with candidates, employees, and vendors via in-app messaging',
                'Coordinate interviews and manage the onboarding process',
                'Access applicant database and dashboard insights in real time',
                'Streamline your hiring — from sourcing to selection.',
            ],
        },
        {
            key: 'employees',
            label: 'Employees',
            headline: ' Explore Opportunities. Grow Internally.',
            content: [
                'Apply for internal job roles and vendor projects',
                'Create your profile to showcase skills and experience',
                'Participate in mock interview sessions with peers',
                'Track application status and interview feedback',
                'Contribute to internal hiring simulations and peer assessments'
            ],
        },
        {
            key: 'vendors',
            label: 'Vendor',
            headline: 'Collaborate with Ease. Hire with Confidence.',
            content: ['Post job requirements and external projects', 'Manage received applications with status tracking', 'Connect directly with HR/Admins for smoother coordination', 'Build a reliable vendor profile to attract more opportunities', 'Gain visibility across the company talent pool'],
        },
        {
            key: 'superadmin',
            label: 'Super Admin',
            headline: 'Govern, Configure, Oversee — All in One Place',
            content: ['Create and manage HR/Admin roles with defined access', 'Assign responsibilities by group or department', 'Monitor platform-wide activity and hiring workflows', 'Access system-wide metrics and compliance dashboards', 'Maintain secure, structured, and scalable recruitment operations'],
        },
    ];
    const faqData = [
        {
            id: 1,
            question: "What is Besto HRMS and how is it different from other HR tools?",
            answer: "Besto HRMS is a recruitment-focused human resource management platform seamlessly integrated with Call for Naukri. Unlike generic HR tools, it offers deep features tailored to manage job postings, candidate screening, vendor collaboration, internal employee applications, and role-based access for every stakeholder involved in hiring.",
            icon: <HelpCircle className="w-5 h-5" />,
            category: "Platform Overview"
        },
        {
            id: 2,
            question: "How is Besto HRMS connected to Call for Naukri?",
            answer: "Call for Naukri is the candidate-facing platform where job seekers apply for roles. All applications submitted there are instantly accessible to recruiters and admins in Besto HRMS, making the entire process unified and streamlined.",
            icon: <Zap className="w-5 h-5" />,
            category: "Integration"
        },
        {
            id: 3,
            question: "Can employees apply for internal and vendor-posted jobs?",
            answer: "Yes! Registered employees can explore and apply for both internal job openings and external vendor-posted projects right from their Besto HRMS dashboard. They can also participate in mock interviews and track their application status.",
            icon: <Users className="w-5 h-5" />,
            category: "Employee Access"
        },
        {
            id: 4,
            question: "What access controls are available for different roles?",
            answer: "Besto HRMS uses strict role-based access control. Super Admins define access privileges. HR/Admins handle recruitment operations, Vendors post and manage job requirements, and Employees can view and apply for jobs. Each role sees only what they're supposed to.",
            icon: <Shield className="w-5 h-5" />,
            category: "Security"
        },
        {
            id: 5,
            question: "Is the platform secure and customizable for my organization?",
            answer: "Absolutely. Besto HRMS uses Multi-Factor Authentication (MFA), data encryption, and custom subdomains (like yourcompany.bestohrms.com) to ensure security and brand alignment. It also offers customizable workflows and templates to fit your unique hiring process.",
            icon: <Settings className="w-5 h-5" />,
            category: "Security & Customization"
        },
        {
            id: 6,
            question: "Can I track and evaluate applications automatically?",
            answer: "Yes. Besto HRMS features a resume/CV matcher that scores candidates based on how well their profile matches the job description. This helps recruiters focus on top-matched applications and reduce manual shortlisting time.",
            icon: <Target className="w-5 h-5" />,
            category: "Automation"
        }
    ];

    const features = [
        {
            icon: <i className="material-icons text-blue-600 mb-4 text-[62px]">person</i>,
            title: 'Smart Candidate Screening',
            description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy',
        },
        {
            icon: <i className="material-icons text-blue-600 mb-4 text-[62px]">account_tree</i>,
            title: 'Collaborative Hiring Pipelines',
            description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy',
        },
        {
            icon: <i className="material-icons text-blue-600 mb-4 text-[62px]">smart_toy</i>
            ,
            title: 'Automated Interview Scheduling',
            description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy',
        },
        {
            icon: <i className="material-icons text-blue-600 mb-4 text-[62px]">bar_chart</i>,
            title: 'Analytics & Compliance Reporting',
            description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy',
        },
    ];
    const data1 = [
        {
            title: "Overview",
            points: [
                "Comprehensive project analysis and scope definition",
                "Market research and competitive landscape review",
                "Initial requirements gathering and documentation",
                "Stakeholder alignment and expectation setting"
            ]
        },
        {
            title: "Planning",
            points: [
                "Detailed project timeline and milestone creation",
                "Resource allocation and team assignment",
                "Risk assessment and mitigation strategies",
                "Budget planning and cost estimation"
            ]
        },
        {
            title: "Design",
            points: [
                "User experience research and persona development",
                "Wireframing and prototyping iterations",
                "Visual design system and brand guidelines",
                "Accessibility standards implementation"
            ]
        },
        {
            title: "Development",
            points: [
                "Frontend architecture and component development",
                "Backend API design and database optimization",
                "Quality assurance and testing protocols",
                "Performance optimization and security measures"
            ]
        },
        {
            title: "Launch",
            points: [
                "Production deployment and environment setup",
                "User training and documentation delivery",
                "Performance monitoring and analytics setup",
                "Post-launch support and maintenance planning"
            ]
        }
    ];


    const steps = [
        { icon: <WorkOutline fontSize="large" />, label: 'Create Job' },
        { icon: <Article fontSize="large" />, label: 'Post on Call for Naukri' },
        { icon: <Search fontSize="large" />, label: 'Screen & Shortlist' },
        { icon: <Groups fontSize="large" />, label: 'Interview' },
        { icon: <HowToReg fontSize="large" />, label: 'Hire' },
    ];
    const testimonials = [
        {
            name: "Anjali Mehta",
            role: "Senior HR Manager",
            rating: 4,
            text: "Besto HRMS has completely transformed how we manage recruitment. From posting jobs to screening candidates and coordinating with vendors — everything is smooth and centralized."
        },
        // duplicate objects or map over real data
        {
            name: "Rohit Pawar",
            role: "Software Developer",
            rating: 5,
            text: "As an employee, I love having the option to apply for internal roles and vendor projects without any paperwork. The mock interview feature helped me sharpen my skills and land a promotion!"
        },
        {
            name: "Priya Nair",
            role: "Talent Partner",
            rating: 4,
            text: "We’ve collaborated with many companies, but Besto HRMS makes it easier than ever. Posting job requirements, tracking applications, and direct communication with HR teams — all under one roof."
        },
        {
            name: "Sandeep Kulkarni",
            role: "Super Admin",
            rating: 5,
            text: "Managing multiple admins, assigning roles, and overseeing recruitment workflows across departments used to be chaotic. With Besto HRMS, I finally have complete control and visibility — all in one intuitive dashboard."
        },

    ];
    const [activeTab, setActiveTab] = useState('hr');

    const currentTab = tabs.find((tab) => tab.key === activeTab);

    const filteredFAQs = useMemo(() => {
        if (!searchTerm) return faqData;
        return faqData.filter(faq =>
            faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
            faq.answer.toLowerCase().includes(searchTerm.toLowerCase()) ||
            faq.category.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [searchTerm]);

    const toggleItem = (index) => {
        const newOpenItems = new Set(openItems);
        if (newOpenItems.has(index)) {
            newOpenItems.delete(index);
        } else {
            newOpenItems.add(index);
        }
        setOpenItems(newOpenItems);
    };

    const expandAll = () => {
        setOpenItems(new Set(filteredFAQs.map((_, index) => index)));
    };

    const collapseAll = () => {
        setOpenItems(new Set());
    };
    const data = [
        {
            title: "Amplify Your Hiring Pipeline",
            points: [
                "Integrated Job Posting: Distribute job openings across multiple platforms, including Call for Naukri, to maximize visibility.",
                "Company-Specific Subdomains: Enhance your brand with personalized subdomains like yourcompany.bestohrms.com.",
                "Employee & Vendor Portals: Facilitate internal job applications and vendor collaborations through dedicated portals.",
            ],
        },
        {
            title: "Track & Engage Efficiently",
            points: [
                "Advanced Applicant Tracking: Monitor candidate progress through customizable pipelines.",
                "Resume/CV Matching: Leverage AI to match applications with job descriptions, scoring candidates for optimal fit.",
                "Real-Time Dashboards: Gain insights into recruitment metrics, application statuses, and team performance.",
            ],
        },
        {
            title: "Collaborate Seamlessly",
            points: [
                "Multi-Factor Authentication (MFA): Ensure secure access for all users.",
                "In-App Messaging: Facilitate direct communication between HR/Admin and candidates or vendors.",
                "Mock Interviews: Enable employees to conduct practice interviews, fostering a culture of continuous improvement.",
            ],
        },
        {
            title: "Secure & Compliant",
            points: [
                "Data Security: Protect sensitive information with robust encryption and compliance with data protection regulations.",
                "Role-Based Access Control: Assign permissions based on user roles to maintain data integrity.",
                "Audit Trails: Maintain comprehensive logs for all activities within the system.",
            ],
        },
    ];
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (

        <>

            <section
                className="relative bg-cover bg-center h-[500px] flex lg:items-center justify-start"
                style={{
                    backgroundImage: `url(${bgImage})`,
                }}
            >
                <div className="glass-card p-8 lg:ml-8 lg:m-auto max-w-md-[28px] shadow-md homecard">
                    <h1 className="text-4xl font-extrabold text-white shadow-text mb-4 leading-tight">
                        <strong>Besto HRMS</strong><br />
                        <span className='text-[20px] '>Revolutionizing Recruitment Management</span>
                    </h1>
                    <p className="text-white shadow-text mb-6 w-auto lg:max-w-[400px]">
                        Empower your recruitment process with Besto HRMS, a comprehensive solution seamlessly integrated with Call for Naukri. Designed for HR professionals, recruiters, vendors, and candidates, Besto HRMS streamlines every facet of hiring
                    </p>
                    <div className="flex gap-4">
                        {/* <a href="#contact">

                            <button className="text-[#CCE0FF] font-[400] text-[16px] hover:outline hover:outline-1 hover:outline-[#CCE0FF] rounded px-4 py-2 transition-all" ref={contactRef}>
                                See How It Works
                            </button></a> */}
                        <a href="#contact">
                            <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
                                Get Started Free
                            </button>
                        </a>


                    </div>
                </div>



            </section>
            <section className='mt-15'>
                <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 px-4 py-16">
                    <div className="max-w-6xl mx-auto">
                        {/* Header */}
                        <div className="text-center mb-8">
                            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">Smarter Hiring. Simplified.</h1>
                            <p className="text-[#333]">Besto HRMS unifies your recruitment journey from start to finish.</p>
                        </div>

                        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                            <div className="steps flex min-h-[500px]">
                                {/* Left Tabs with Enhanced Design */}
                                <div className=" w-auto lg:w-80 bg-gradient-to-b from-gray-50 to-gray-100 border-r border-gray-200 flex justify-center">


                                    {/* Tabs */}
                                    <div className="p-4">

                                        {/* Desktop & Tablet View (Vertical, Number + Text) */}
                                        <div className="space-y-2 hidden md:flex md:flex-col md:justify-center">
                                            {data.map((item, index) => (
                                                <div key={index} className="relative">
                                                    <button
                                                        onClick={() => setActiveIndex(index)}
                                                        className={`w-full text-left p-4 rounded-xl transition-all duration-300 transform hover:scale-[1.02] hover:shadow-md mb-4 group ${activeIndex === index
                                                            ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/25'
                                                            : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600 shadow-sm'
                                                            }`}
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center space-x-3">
                                                                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${activeIndex === index
                                                                    ? 'bg-white text-blue-500'
                                                                    : 'bg-blue-100 text-blue-600 group-hover:bg-blue-200'
                                                                    }`}>
                                                                    {index + 1}
                                                                </div>
                                                                <span className="font-medium">{item.title}</span>
                                                            </div>
                                                            <ChevronRight className={`w-4 h-4 transition-transform duration-300 ${activeIndex === index ? 'rotate-90 text-white' : 'text-gray-400 group-hover:text-blue-500'
                                                                }`} />
                                                        </div>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Mobile View (Horizontal, Numbers Only) */}
                                        <div className="flex justify-between md:hidden gap-2">
                                            {data.map((_, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => setActiveIndex(index)}
                                                    className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-300 ${activeIndex === index
                                                        ? 'bg-blue-500 text-white'
                                                        : 'bg-blue-100 text-blue-600'
                                                        }`}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>

                                    </div>

                                </div>

                                {/* Vertical Divider */}

                                {/* Right Content with Enhanced Design */}
                                <div className="flex-1 lg:p-8 p-2">
                                    {/* Content Header */}
                                    <div className="mb-8">
                                        <div className="flex items-center space-x-3 mb-4">
                                            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                                                <span className="text-blue-600 font-bold text-lg">{activeIndex + 1}</span>
                                            </div>
                                            <h2 className="text-2xl font-bold text-gray-800">{data[activeIndex].title}</h2>
                                        </div>
                                        <div className="lg:w-20 lg:h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
                                    </div>

                                    {/* Content Points */}
                                    <div className="space-y-4">
                                        {data[activeIndex].points.map((point, idx) => (
                                            <div
                                                key={idx}
                                                className="flex items-start space-x-4 p-4 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors duration-200 transform hover:translate-x-1"
                                                style={{
                                                    animationDelay: `${idx * 100}ms`,
                                                    animation: 'fadeInUp 0.5s ease-out forwards'
                                                }}
                                            >
                                                <div className="flex-shrink-0 mt-2">
                                                    <Circle className="w-2 h-2 fill-blue-500 text-blue-500" />
                                                </div>
                                                <p className="text-gray-700 leading-relaxed">{point}</p>
                                            </div>
                                        ))}
                                    </div>


                                </div>
                            </div>
                        </div>

                        {/* Navigation Dots */}
                        <div className="flex justify-center space-x-2 mt-6">
                            {data.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setActiveIndex(index)}
                                    className={`w-3 h-3 rounded-full transition-all duration-300 ${activeIndex === index
                                        ? 'bg-blue-500 scale-125'
                                        : 'bg-gray-300 hover:bg-blue-300'
                                        }`}
                                />
                            ))}
                        </div>
                    </div>

                    <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
                </div>
            </section>
            {/* <section className="py-16 lg:py-[80px] bg-white text-center">
                <h2 className="text-3xl font-bold text-gray-800 mb-12 relative inline-block">
                    <span className="text-[30px] lg:text-[48px] font-[600] pb-2">Feature Highlights</span>
                </h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto px-4">
                    {features.map((feature, idx) => (
                        <div key={idx} className="text-left">
                            {feature.icon}
                            <h3 className="text-[18px] lg:text-[24px] font-[500] mb-2">{feature.title}</h3>
                            <p className="text-[16px] font-[400] text-[#666] mb-4">{feature.description}</p>
                            <a
                                href="#"
                                className="relative group block w-full overflow-hidden rounded py-2 pr-4 h-[40px]"
                            >
                                <span className="absolute inset-0 bg-on-hover rounded z-0"></span>

                                <span className="absolute slide-right z-10 font-medium text-[#006AFF] whitespace-nowrap">
                                    See More →
                                </span>
                            </a>
                        </div>
                    ))}
                </div>

            </section> */}
            {/* <section className="py-15">
            <div
                className="bg-cover bg-center py-16 text-white"
                style={{
                    backgroundImage: `url(${gear})`,
                }}
            >
                <h2 className="text-[24px] sm:text-[32px] lg:text-[48px] font-[500] text-center mb-8">
                    How it Works
                </h2>

                <div className="flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-[130px] px-4">
                    {steps.map((step, idx) => (
                        <div key={idx} className="flex flex-col lg:flex-row items-center gap-3">
                            <div className="flex flex-col items-center text-center">
                                <div className="bg-black/70 w-20 h-20 lg:w-[96px] lg:h-[96px] flex items-center justify-center rounded-full shadow-lg">
                                    {step.icon}
                                </div>
                                <p className="text-[18px] sm:text-[20px] lg:text-[24px] font-[400] mt-2 text-white">
                                    {step.label}
                                </p>
                            </div>

                            {idx < steps.length - 1 && (
                                <span className="text-white text-2xl">
                                    <span className="block lg:hidden">↓</span>
                                    <span className="hidden lg:block">→</span>
                                </span>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section> */}
            <section className="bg-gradient-to-r from-[#0d1d3c] to-[#0c3483] text-white py-16 text-center px-4">
                <div className="max-w-4xl mx-auto">
                    {/* Heading */}
                    <h1 className="text-3xl md:text-5xl font-bold mb-4">
                        Designed for All <span className="text-cyan-400">Recruitment</span>{' '}Stakeholders

                    </h1>

                    {/* Subheading */}
                    <p className="text-lg md:text-xl text-white/90 mb-8">
                        Streamline hiring, enhance collaboration, and maintain security with our <br className="hidden md:block" />
                        comprehensive HR management platform
                    </p>

                    {/* Button Tabs */}
                    <div className="flex flex-wrap justify-center gap-4 mb-10">
                        {tabs.map((tab) => (
                            <button
                                key={tab.key}
                                onClick={() => setActiveTab(tab.key)}
                                className={`px-6 py-2 rounded-full font-medium transition-colors duration-200 ${activeTab === tab.key
                                    ? 'bg-white text-[#3d0066]'
                                    : 'bg-white/10 hover:bg-white/20 text-white'
                                    }`}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>

                    {/* Tab Content */}
                    <div className="bg-white text-gray-800 rounded-lg p-6 shadow-lg text-left">
                        <h2 className="text-xl md:text-2xl font-semibold mb-4">{currentTab.headline}</h2>
                        <ul className="list-disc list-inside pl-5 space-y-2 text-gray-700 marker:text-blue-500">
                            {currentTab.content.map((item, idx) => (
                                <li key={idx}>{item}</li>
                            ))}
                        </ul>

                    </div>
                </div>
            </section>
            <section className='py-15'>
                <div className="bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-12 px-6">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent text-center">Besto HRMS in Their Words.</h2>
                    <p className="text-lg text-center md:text-xl text-[#333]/90 mb-8">Real Results. Real Experiences.</p>
                    <div className="relative max-w-6xl mx-auto">
                        <Swiper
                            modules={[Navigation]}
                            navigation={{
                                nextEl: '.next-btn',
                                prevEl: '.prev-btn',
                            }}
                            spaceBetween={30}
                            breakpoints={{
                                0: { slidesPerView: 1 },        // Mobile: 1 slide
                                768: { slidesPerView: 2 },      // Tablet: 2 slides
                                1024: { slidesPerView: 3 },     // Desktop: 3 slides
                            }}
                            loop
                            className="pb-10"
                        >
                            {testimonials.map((item, idx) => (
                                <SwiperSlide key={idx}>
                                    <div className="clientcard rounded-xl p-6 shadow-md h-full lg:max-h-[395px] w-full">
                                        <FaQuoteLeft className="text-blue-500 text-3xl mb-4" />
                                        <p className="text-[#333] font-[500] text-[16px] mb-4">{item.text}</p>
                                        <div className="flex items-center mt-auto gap-3">
                                            <div className="w-10 h-10 bg-gray-300 rounded-full" />
                                            <div className="text-sm">
                                                <p className="text-[16px]">{item.name}</p>
                                                <p className="text-gray-500">{item.role}</p>
                                                <p className="text-gray-400 text-xs">{item.date}</p>
                                            </div>
                                        </div>
                                        <div className="flex items-center mt-4 mb-3">
                                            {[...Array(5)].map((_, i) =>
                                                i < item.rating ? (
                                                    <FaStar key={i} className="text-[#FFC727]" />
                                                ) : (
                                                    <FaRegStar key={i} className="text-[#ccc] bg-white" />
                                                )
                                            )}
                                            <span className="ml-2 text-sm text-gray-500">{item.rating}/5</span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        {/* Navigation Arrows */}
                        <button className="prev-btn absolute top-1/2 left-[-10px] transform -translate-y-1/2 bg-[#11244c] p-3 rounded-full text-white shadow-md z-10">
                            <FaArrowLeft />
                        </button>
                        <button className="next-btn absolute top-1/2 right-[-10px] transform -translate-y-1/2 bg-[#11244c] p-3 rounded-full text-white shadow-md z-10">
                            <FaArrowRight />
                        </button>
                    </div>

                </div>
            </section>

            {/* <section className="bg-gradient-to-r from-[#3d0066] via-[#4b0082] to-[#e75480] text-white py-16 text-center px-4">
                <div className="max-w-4xl mx-auto">
             
                    <h1 className="text-3xl md:text-5xl font-bold mb-4">
                        Transform Your <span className="text-cyan-400">HR</span> <span className="text-pink-400">Operations</span>
                    </h1>

                  
                    <p className="text-lg md:text-xl text-white/90 mb-8">
                        Streamline hiring, enhance collaboration, and maintain security with our <br className="hidden md:block" />
                        comprehensive HR management platform
                    </p>

                  
                    <div className="flex flex-wrap justify-center gap-4">
                        <button className="bg-white/10 hover:bg-white/20 text-white font-medium px-6 py-2 rounded-full">
                            HR/Admin
                        </button>
                        <button className="bg-white/10 hover:bg-white/20 text-white font-medium px-6 py-2 rounded-full">
                            Employess
                        </button>
                        <button className="bg-white/10 hover:bg-white/20 text-white font-medium px-6 py-2 rounded-full">
                            Vendor
                        </button>
                        <button className="bg-white text-[#3d0066] hover:bg-gray-200 font-medium px-6 py-2 rounded-full">
                            Super Admin
                        </button>
                    </div>
                </div>
            </section> */}

            <section className="py-16 px-8 bg-gradient-to-r from-[#0d1d3c] to-[#0c3483] min-h-screen">
                <div className="mx-auto">
                    {/* Header */}
                    <div className="text-center mb-12">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl mb-6 shadow-lg">
                            <HelpCircle className="w-8 h-8 text-white" />
                        </div>
                        <h2 className="text-3xl md:text-5xl font-bold mb-4 text-[#fff]">
                            Got Questions?
                        </h2>
                        <p className="text-xl text-[#fff] mb-8">We've Got Answers.</p>

                        {/* Search Bar */}
                    </div>

                    {/* FAQ Items */}
                    <div className="space-y-4 mx-auto max-w-6xl">
                        {filteredFAQs.length === 0 ? (
                            <div className="text-center py-12">
                                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <Search className="w-6 h-6 text-gray-400" />
                                </div>
                                <p className="text-gray-500 text-lg">No FAQs found matching your search.</p>
                            </div>
                        ) : (
                            filteredFAQs.map((faq, index) => (
                                <div
                                    key={faq.id}
                                    className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-all duration-300 group"
                                >
                                    <button
                                        onClick={() => toggleItem(index)}
                                        className="w-full text-left lg:p-6 p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
                                    >
                                        <div className="flex items-start justify-between">
                                            <div className="flex items-start space-x-4 flex-1">
                                                <div className="flex-shrink-0 h-auto w-auto lg:w-10 lg:h-10 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-xl flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-200">
                                                    {faq.icon}
                                                </div>
                                                <div className="flex-1">
                                                    <div className="inline-block px-3 py-1 text-xs font-medium text-blue-600 bg-blue-50 rounded-full mb-2">
                                                        {faq.category}
                                                    </div>
                                                    <h3 className="lg:text-lg sm:text-[16px] font-semibold text-gray-900 leading-tight group-hover:text-blue-600 transition-colors duration-200">
                                                        {faq.question}
                                                    </h3>
                                                </div>
                                            </div>
                                            <div className="flex-shrink-0 ml-4">
                                                <ChevronDown
                                                    className={`w-6 h-6 text-gray-400 transition-all duration-300 ${openItems.has(index) ? 'rotate-180 text-blue-500' : 'group-hover:text-gray-600'
                                                        }`}
                                                />
                                            </div>
                                        </div>
                                    </button>

                                    <div
                                        className={`transition-all duration-300 ease-in-out ${openItems.has(index)
                                            ? 'max-h-96 opacity-100'
                                            : 'max-h-0 opacity-0'
                                            } overflow-hidden`}
                                    >
                                        <div className="px-6 pb-6">
                                            <div className="lg:ml-14 pt-2 lg:border-l-2 border-blue-100 lg:pl-6">
                                                <p className="text-gray-700 leading-relaxed">
                                                    {faq.answer}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>

                    {/* Bottom CTA */}
                    <div className="mt-16 text-center mx-auto max-w-6xl">
                        <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">
                                Make Hiring Smarter, Faster, and More Collaborative
                            </h3>
                            {/* <p className="text-gray-600 mb-6">
                                Our support team is here to help you get the most out of Besto HRMS.
                            </p> */}
                            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                <a href="#contact">
                                    <button className="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" href='#contact'>
                                        Talk to our Team
                                    </button></a>
                                <a href="#contact">

                                    <button className="px-6 py-3 border border-gray-200 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-colors duration-200" >
                                        Schedule Demo
                                    </button></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className=" bg-gradient-to-r from-[#0d1d3c] to-[#0c3483] min-h-screen" id='contact' ref={contactRef}>
                <div className="bg-[#f9fbfd] min-h-screen flex flex-col px-4 py-12">
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent text-center">
                        Contact Us
                    </h2>
                    <p className="text-[400] lg:text-[20px] text-[#666] text-center mb-8">
                        Feel free to reach out with any questions or inquiries.
                    </p>

                    <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 w-full max-w-6xl mx-auto">
                        {/* Left Image Section */}
                        <div className="flex-1 w-full">
                            <img
                                src={gear}
                                className="w-full h-auto object-cover rounded-xl shadow-md"
                            />
                        </div>

                        {/* Right Form Section */}
                        <div className="flex-1 w-full max-w-md">
                            <form className="bg-[#F0F4F9] p-6 lg:px-[24px] lg:py-[32px] rounded-[24px] space-y-4 shadow">
                                <div>
                                    <label className="text-sm font-[500] text-[#333]">Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter name"
                                        className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm font-[500] text-[#333]">Email</label>
                                    <input
                                        type="email"
                                        placeholder="Enter email id"
                                        className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm font-[500] text-[#333]">Subject</label>
                                    <input
                                        type="text"
                                        placeholder="Enter subject"
                                        className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm font-[500] text-[#333]">Message</label>
                                    <textarea
                                        placeholder="Enter message"
                                        rows="3"
                                        className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    ></textarea>
                                </div>

                                <button
                                    type="submit"
                                    className="flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"
                                >
                                    <SendIcon fontSize="small" />
                                    Send
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <section className="relative py-16 px-8 bg-gradient-to-r from-[#0d1d3c] to-[#0c3483]">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_0.75fr] gap-6 items-center text-center md:text-left">

                        {/* Column 1: Copyright (Widest) */}
                        <div>
                            <p className="text-gray-300 text-sm">
                                © 2025 Bhalchandraya Innovative Services Pvt. Ltd. All Rights Reserved.
                            </p>
                        </div>

                        {/* Column 2: Quick Links (Smaller) */}
                        <div className="flex space-x-4 justify-center">
                            <NavLink to="/terms_condition" className="text-white text-sm hover:underline">
                                Terms & Conditions
                            </NavLink>
                            <NavLink to="/privacy_policy" className="text-white text-sm hover:underline">
                                Privacy Policy
                            </NavLink>
                        </div>

                        {/* Column 3: Social Media (Smallest) */}
                        <div className="flex justify-center md:justify-end space-x-4">
                            <a
                                href="https://www.linkedin.com/company/besto-hrms/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white/10 hover:bg-white/20 p-3 rounded-full transition-all duration-300 hover:scale-110"
                            >
                                <FaLinkedinIn className="text-white text-lg" />
                            </a>
                            <a
                                href="https://www.facebook.com/share/1AozNQGpPs/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-white/10 hover:bg-white/20 p-3 rounded-full transition-all duration-300 hover:scale-110"
                            >
                                <FaFacebookF className="text-white text-lg" />
                            </a>
                        </div>

                    </div>
                </div>



                {/* Scroll to Top Button */}
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-8 right-8 bg-white text-[#0c3483] hover:bg-gray-100 p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
                    aria-label="Scroll to top"
                >
                    <FaArrowUp className="text-lg" />
                </button>
            </section>

        </>

    );
};

export default HeroSection;
